<template>
  <v-autocomplete
    v-model="selectedItems"
    :item-text="itemText"
    v-bind="$attrs"
    class="story-city-autocomplete-input mb-0"
    hide-details="auto"
    single-line
    outlined
    solo
    flat
    chips
    deletable-chips
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        class="select-chip"
        :input-value="data.selected"
        close
        dark
        close-icon="mdi-close"
        color="primaryFaded"
        @click:close="removeItem(data.item)"
      >
        <div class="chip-text">{{ data.item[itemText] }}</div>
      </v-chip>
    </template>
    <template v-slot:append>
      <v-icon size="14">$arrow</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
    },
    itemText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedItems: this.value,
    };
  },
  watch: {
    selectedItems(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      if (this.selectedItems !== newValue) {
        this.selectedItems = newValue;
      }
    },
  },
  methods: {
    removeItem(itemToRemove) {
      const index = this.selectedItems.indexOf(itemToRemove.id);
      if (index >= 0) {
        if (Array.isArray(this.selectedItems)) {
          this.selectedItems.splice(index, 1);
        }
        else {
          this.selectedItems = null;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-chip.select-chip {
  height: 30px;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: $font-spacing;
  margin: 2px 4px 2px 0;
}

.chip-text {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
